/**
 * Тексты маршрутизации чата рецептов (оффтоп / редирект в «Помощь маме»).
 * Источник правды для Edge (deepseek-chat) и клиентского fallback (chatRouteFallback).
 */

export const CHAT_MESSAGE_IRRELEVANT = `Мы помогаем подбирать блюда и идеи для готовки 💛
Попробуйте уточнить, что вы хотите приготовить — и мы предложим подходящий вариант.`;

export const CHAT_MESSAGE_ASSISTANT_REDIRECT = `Похоже, этот вопрос лучше разобрать во вкладке «Помощь маме» 💛
Там мы сможем помочь точнее.`;
